import { useContext } from "react"
import { EditorToolbarButton, EditorToolbarColorDropdown, EditorToolbarTray } from "./EditorToolbarUI";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const EditorTableTray = ({context}) => {
    const { editor, editorState } = useContext(context);

    return (
        <EditorToolbarTray>
            <EditorToolbarButton
                icon={<MaterialIcon name='table' weight={300}/>}
                onClick={() => editor.chain().focus().insertTable({rows: 3, cols: 3, withHeaderRow: false}).run()}
            />
            {
                editorState.isInTable ? 
                <>
                    <EditorToolbarColorDropdown
                    icon={<MaterialIcon name='colors' weight={300}/>}
                    defaultValue={"FFFFFFFFF"}
                    selectedValue={editorState.currentCellBackground}
                    onChange={(value) => editor.chain().focus().updateAttributes('tableCell', { backgroundColor: value }).run()}
                    highlight
                    />
                    <EditorToolbarButton
                        icon={<MaterialIcon name='cell_merge' weight={300}/>}
                        active={editorState.isCellMerged}
                        onClick={() => {
                            if(editorState.isCellMerged) editor.commands.splitCell();
                            else editor.commands.mergeCells();
                        }}
                    />
                </>
                : null
            }
            
        </EditorToolbarTray>
    )
}

